import { useToast } from '@chakra-ui/react';
import CheckIcon from '../../../../components/icons/CheckIcon';
import ToastContentBox from '../../../../components/toast/ToastContentBox';
import { t } from 'i18next';

export const useSuccessPhotoCardToast = () => {
  const toast = useToast();

  const showSuccessToast = (
    position: 'top' | 'bottom' = 'bottom',
    message = t('photoCardPage.successToastMessage'),
    showCheckIcon = true,
    icon: React.ReactNode = null,
    isDarkMode = false
  ) => {
    toast({
      duration: 2000,
      position: position,
      render: () => (
        <ToastContentBox
          startElement={
            showCheckIcon ? (
              <div className="p-[2.5px]">
                <CheckIcon className="fill-white bg-onSuccess-light dark:bg-onSuccess-dark rounded-full w-[15px] h-[15px] p-[3px]" />
              </div>
            ) : icon ? (
              icon
            ) : null
          }
          position={position}
          message={message}
          isDarkMode={isDarkMode}
        />
      )
    });
  };
  return showSuccessToast;
};
